<vex-page-layout>
  <vex-page-layout-content>
    <div
      class="slc-dashboard relative z-10"
      cdkDropList
      cdkDropListOrientation="mixed"
      (cdkDropListDropped)="onDropCard($event)"
      [cdkDropListData]="cardsPrefUsuario"
    >
      @for (card of cardsPrefUsuario(); track card.id) {
      <div
        cdkDrag
        class="resizable z-10"
        [style.grid-column]="
          'span ' + card.colunasGrid + '/ span ' + card.colunasGrid
        "
        [style.grid-row]="
          'span ' + card.linhasGrid + '/ span ' + card.linhasGrid
        "
        [attr.data-cols]="card.colunasGrid"
        [attr.data-rows]="card.linhasGrid"
      >
        <app-dashboard-card [cardId]="card.id"></app-dashboard-card>
        <div class="resize-handle" (mousedown)="onStartResize($event, card)">
          <mat-icon svgIcon="mat:open_in_new" class="text-gray-500"></mat-icon>
        </div>
      </div>
      }
      <div
        #guiaGrid
        class="slc-dashboard absolute inset-0 -z-10"
        [class.invisible]="!resizing()"
      >
        <div #guiaCard class="bg-gray-200"></div>
        @for (guia of guiasArray(); track $index) {
        <div class="bg-gray-200"></div>
        }
      </div>
    </div>
  </vex-page-layout-content>
</vex-page-layout>

<div class="fixed right-5 bottom-5 z-50">
  <button
    mat-fab
    class="slc-btn-fab-brand ease-in duration-300 hover:scale-125"
    (click)="selecionarCardSidebar.open()"
  >
    <mat-icon matIconPrefix svgIcon="mat:add" class="icon-xl"></mat-icon>
  </button>
</div>

<!-- Selecionar Card -->
<vex-sidebar
  #selecionarCardSidebar
  position="right"
  [invisibleBackdrop]="false"
>
  <!-- If para forçar o componente a reinicializar -->
  @if (selecionarCardSidebar.opened) {
  <app-dashboard-selecionar-card
    [sidebarComponent]="selecionarCardSidebar"
  ></app-dashboard-selecionar-card>
  }
</vex-sidebar>
